import React, { useEffect, useState } from 'react';
import ProductCard, { Product } from './ProductCard';

const API_URL = '';

const TodayDeals: React.FC = () => {
  const [bestSellers, setBestSellers] = useState<Product[]>([]);
  const [hotDeals, setHotDeals] = useState<Product[]>([]);

  useEffect(() => {
    const ctrl = new AbortController();
    const signal = ctrl.signal;
    // 베스트셀러: 최신 상품 3개
    fetch(`${API_URL}/api/storefront/list?limit=3&offset=0&published=1`, { signal })
      .then(r => r.json())
      .then(data => { if (!signal.aborted) setBestSellers(data.products || []); })
      .catch(() => {});

    // 꽁돈대첩: 다음 3개
    fetch(`${API_URL}/api/storefront/list?limit=3&offset=3&published=1`, { signal })
      .then(r => r.json())
      .then(data => { if (!signal.aborted) setHotDeals(data.products || []); })
      .catch(() => {});
    return () => ctrl.abort();
  }, []);

  return (
    <div className="today-deals">
      <div className="deals-grid">
        <div className="deal-section">
          <h3>베스트셀러</h3>
          <div className="deal-subtitle">
            <span>🛒 가성비 넘치는 아이템 추천</span>
          </div>
          <div className="deal-products">
            {bestSellers.map(p => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </div>
        <div className="deal-section">
          <h3>꽁돈대첩</h3>
          <div className="deal-subtitle">
            <span>⏰ 최대 80% 할인</span>
          </div>
          <div className="deal-products">
            {hotDeals.map(p => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodayDeals;
